import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/collections/redux/actions';
import * as commonActions from '../../features/common/redux/actions';
import CustomFilterBuilder from './collection/derived-query/CustomFilterBuilder';
import CustomLoader from '../common/CustomLoader';
import CollectionHeaderNav from './CollectionHeaderNav';
import types from '../../common/formElements/CollectionSectionType';
import { drapcodeIcon } from '../../common/custom/icon-library';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import FilterDoc from './collection/derived-query/FilterDoc';
import VideoBox from '../../common/custom/VideoBox';
import { FILTER } from 'drapcode-constant';

export class Filters extends Component {
  static propTypes = {
    collections: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    commonActions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, collectionId, version } = match.params;
    actions.loadProjectCollections({ projectId, version });
    actions.loadProjectCollectionDetail({ projectId, collectionId, version });
    actions.loadProjectPlugins({ projectId, version });
    actions.getPermissionFlags({ projectId });
    commonActions.loadCollectionChange();
  }

  render() {
    const { collections, match, actions, common, commonActions } = this.props;
    const { projectId, collectionId, version } = match.params;
    const {
      loadProjectCollectionsPending,
      loadProjectCollectionDetailPending,
      addQueryToCollectionPending,
      selectedCollection,
      permissionFlags,
    } = collections;
    const { updatedCollections } = common;
    let permissionsArray = [];
    if (permissionFlags && permissionFlags.length > 0) {
      permissionsArray = permissionFlags || [];
    }

    return (
      <CommonPageComponent>
        <CollectionHeaderNav
          label={types.FILTER}
          projectId={projectId}
          version={version}
          selectedCollection={selectedCollection}
          loadProjectCollectionsPending={loadProjectCollectionsPending}
          loadProjectCollectionDetailPending={loadProjectCollectionDetailPending}
        />
        {loadProjectCollectionsPending ||
          (loadProjectCollectionDetailPending && (
            <div className="text-center">
              <CustomLoader
                loading={loadProjectCollectionsPending || loadProjectCollectionDetailPending}
                size="20px"
                color="#303453"
              />
            </div>
          ))}
        {selectedCollection && (
          <div className="row mx-auto">
            <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
              <CustomFilterBuilder
                actions={actions}
                commonActions={commonActions}
                version={version}
                projectId={projectId}
                filters={selectedCollection.finders}
                collection={selectedCollection}
                collections={collections}
                showQueryCreateLoader={addQueryToCollectionPending}
                flag={permissionsArray.includes(FILTER)}
                updatedCollections={updatedCollections}
              />
            </div>
            <FilterDoc />
          </div>
        )}
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    collections: state.collections,
    common: state.common,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    commonActions: bindActionCreators({ ...commonActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Filters);
